<template>
  <div id="vvvideo" class="vvvideo">
    <ul ref="uul" style="width:50px">
      <li @click="abcf(item)" :class="{ active: now == item.channel }" v-for="(item, index) in list" :key="index">
        <div class="changchannel">通道{{ item.channel }}</div>

      </li>
    </ul>
    <div style="width:calc(100% - 50px)">
      <ly-Table :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>" :height="120">
        <template slot-scope="{ row, index }" slot="action">
          <Button size="small" @click="play(row)"> 播放 </Button>
          <Button size="small" @click="downLoad(row, index)">下载</Button>

        </template>
      </ly-Table>
    </div>

  </div>
</template>
<script>

var t;
export default {
  props: ['list'],
  data() {
    return {
      now: 0,
      columns: [{
        title: "通道",
        key: "channel",
      }, {
        title: "设备号",
        key: "device",
      }, {
        title: "开始时间",
        key: "begintime2",
      }, {
        title: "结束时间",
        key: "endtime2",
      }, {
        title: "操作",
        slot: "action",
        width: 160,
        align: "center",
        fixed: "right",
        sort: 12,
      },],
      tableData: []
    };
  },
  methods: {
    abcf(v) {
      this.tableData = v.times;
      console.log(this.tableData);
    },
    play(v) {
      this.$emit('playList', v)
    },
    downLoad(v) {
      this.$emit('downList', v)
    }
  },
  mounted() {


    // this.zzz=350;
  },
  watch: {

  }
};
</script>
<style lang="">
.vvvideo {
  display:flex;
}
.vvvideo li{
  cursor:pointer
}
</style>


// WEBPACK FOOTER //
// src/components/video/videoList.vue